export function clearFIlter() {
    $("button[type='reset']").on("click", function () {
        $(this).parents("form").find("input").attr("value", "");
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/clearFIlter.js